import { customerConstants } from "@_constants/customer.constants";

const initialState = {
  customer: {
    available_translations: {},
    translation: "en",
  },
  loading: true, // Start with loading: true to prevent showing login page before data loads
  message: "",
};

export function customerReducer(state = initialState, action) {
  switch (action.type) {
    case customerConstants.CUSTOMER_REQUEST:
      state = {
        ...state,
        loading: true,
        message: "", // Clear previous error messages when starting a new request
      };
      break;
    case customerConstants.CUSTOMER_SUCCESS:
      state = {
        ...state,
        customer: {
          ...action.data,
        },
        loading: false,
        message: "", // Clear error message on success
      };
      break;
    case customerConstants.CUSTOMER_FAILURE:
      state = {
        ...state,
        customer: {
          // Reset to initial state on failure to avoid using old data
          available_translations: {},
          translation: "en",
        },
        loading: false,
        message: action.error,
      };
      break;
    default:
      break;
  }
  return state;
}
